<template>
  <div id="main-content" class="add-place">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <el-row>
        <el-form :inline="true" class="demo-form-inline">
          <el-form-item>
            <el-button type="success" @click="goToEdit()">{{ is_edit_text }}</el-button>
          </el-form-item>
        </el-form>
      </el-row>
      <form v-if="settingInfo != null">
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star" v-if="is_edit_mode">* </span>
              <span class="form-lable">{{ $t('common.school_name') }}</span>
            </el-col>
            <input v-show="is_edit_mode" class="input" v-model="settingInfo.school_name" type=""/>
            <span v-show="!is_edit_mode" class="info-span"> {{ settingInfo.school_name }} </span>
          </el-col>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star" v-if="is_edit_mode">* </span>
              <span class="form-lable">
                {{ $t('common.phone') }}
              </span>
            </el-col>
            <input v-show="is_edit_mode" class="input" v-model="settingInfo.school_phone" type=""/>
            <span v-show="!is_edit_mode" class="info-span"> {{ settingInfo.school_phone }} </span>
          </el-col>
        </el-row>
        <el-row style="padding-top: 20px">
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star" v-if="is_edit_mode">* </span><span class="form-lable">{{ $t('common.system_name') }}</span>
            </el-col>
            <input v-show="is_edit_mode" class="input" v-model="settingInfo.system_name" type=""/>
            <span v-show="!is_edit_mode" class="info-span"> {{ settingInfo.system_name }} </span>
          </el-col>
        </el-row>

        <el-row v-show="is_edit_mode" style="padding-top: 50px">
          <el-button style="font-size: 20px; width: 30%" type="success" @click="submitAction">{{ $t('common.submit') }}</el-button>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'
  import {mapState} from 'vuex'

  export default {
    name: "SettingSchoolInfo",
    components: {
      PageTitle
    },
    data: function () {
      return {
        backLink: ``,
        title: 'common.school_information',
        is_edit_mode: false,
        is_edit_text: this.$t('common.edit')
      }
    },
    methods: {
      goToEdit: function () {
        this.is_edit_mode = !this.is_edit_mode
        this.is_edit_text = this.is_edit_mode ? this.$t('common.cancel') : this.$t('common.edit')
      },
      submitAction: function () {
        let check = this.validate()
        if (check) {
          let successCallback = () => {
            this.is_edit_mode = false
            this.is_edit_text = this.$t('common.edit')
            return false
          }
          let payload = {
            successCallback,
            data: this.settingInfo
          }

          this.$store.dispatch('settingschool/updateSchoolSetting', payload);
        }
      },
      validate: function () {
        let check = true

        if (this.settingInfo.school_name === '') {
          this.$store.commit('openNotification', {
            type: 'error',
            message: 'Please input school name !'
          })

          return false
        }

        if (this.settingInfo.school_phone === '') {
          this.$store.commit('openNotification', {
            type: 'error',
            message: 'Please input school phone !'
          })

          return false
        }

        if (this.settingInfo.system_name === '') {
          this.$store.commit('openNotification', {
            type: 'error',
            message: 'Please input system name !'
          })

          return false
        }

        return check
      },
    },
    mounted: function () {
      this.$store.dispatch('settingschool/retrieveSettingInfo', {})
    },
    computed: {
      ...mapState('settingschool', ['settingInfo']),
    }
  }
</script>

<style lang="scss">

</style>